<!---->
<template>
	<div class="page-body center-wrap">
		<el-tabs v-model="activeName" @tab-click="handleClick" style="padding: 0 20px;margin: 30px 0px;">
			<el-tab-pane v-for="item in tabsList" :label="item.label" :name="item.value"
				:key="item.value"></el-tab-pane>
		</el-tabs>

		<component :is="current" :title="title" :account="account" ref="componentRef"
			@goOrderTransfer="goOrderTransfer"></component>
	</div>
</template>
<script>
//资产总览
import overviewAssets from './components/overviewAssets';
//资产、合约、期权、理财
import spotAccount from './components/spotAccount';
//法币
import fiatAccount from './components/fiatAccount';
//划转
import orderTransfer from './components/orderTransfer';
//订单
import orderCenter from './components/orderCenter';

import { getQueryParam } from '@/common/public.js';

export default {
	components: {},
	computed: {
		tabsList() {
			return [{
				label: this.$t('资产总览'),
				value: '1',
				current: overviewAssets,
			},
			{
				label: this.$t('资产账户'),
				value: '2',
				current: spotAccount,
			},
			{
				label: this.$t('合约账户'),
				value: '3',
				current: spotAccount,
			},
			{
				label: this.$t('期权账户'),
				value: '4',
				current: spotAccount,
			},
			{
				label: this.$t('理财账户'),
				value: '5',
				current: spotAccount,
			},
			{
				label: this.$t('法币账户'),
				value: '6',
				current: fiatAccount,
			},
			{
				label: this.$t('订单中心'),
				value: '7',
				current: orderCenter,
			},
			{
				label: this.$t('划转'),
				value: '8',
				current: orderTransfer,
			},
			]
		}
	},
	data() {
		return {
			activeName: '',
			current: overviewAssets,
			title: '',
			account: '',
			// tabsList: [{
			// 	label: this.$t('资产总览'),
			// 	value: '1',
			// 	current: overviewAssets,
			// },
			// {
			// 	label: this.$t('资产账户'),
			// 	value: '2',
			// 	current: spotAccount,
			// },
			// {
			// 	label: this.$t('合约账户'),
			// 	value: '3',
			// 	current: spotAccount,
			// },
			// {
			// 	label: this.$t('期权账户'),
			// 	value: '4',
			// 	current: spotAccount,
			// },
			// {
			// 	label: this.$t('理财账户'),
			// 	value: '5',
			// 	current: spotAccount,
			// },
			// {
			// 	label: this.$t('法币账户'),
			// 	value: '6',
			// 	current: fiatAccount,
			// },
			// {
			// 	label: this.$t('订单中心'),
			// 	value: '7',
			// 	current: orderCenter,
			// },
			// {
			// 	label: this.$t('划转'),
			// 	value: '8',
			// 	current: orderTransfer,
			// },
			// ]
		};
	},
	watch: {
		activeName(newVal) {
			// console.log(111)
			const that = this
			this.tabsList.forEach(item => {
				if (item.value == newVal) {
					that.current = item.current
					that.title = item.label
					that.account = Number(item.value) - 1

					that.$nextTick(() => {
						that.$refs.componentRef.init()
					})
				}
			})
		}
	},
	mounted() {

		let key = getQueryParam('key')
		if (key && key == 8) {
			this.goOrderTransfer()
		} else if (key) {
			this.activeName = key
		} else {
			this.activeName = '1'
		}
	},
	beforeUnmount() { },
	methods: {
		handleClick() {
			// console.log(1111,val)
		},
		goOrderTransfer() {
			this.activeName = '8'
		},
	},
};
</script>
<style lang="scss" scoped></style>